<iwt-estatecloud-main-layout>
  @if (showCreateCustomer) {

  <iwt-estatecloud-create-customer />
  } @else {

  <iwt-estatecloud-list-customer />
  }
</iwt-estatecloud-main-layout>
